<template>
  <qx-card-form title="基础信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    />
  </qx-card-form>
</template>

<script>
import {
  orderTimeQueryDriverByPhone,
} from 'api/operate';
export default {
  data () {
    return {
      baseForm: {
        form: [
          {
            label: '订单编号',
            value: 'orderId',
            type: 'input',
            disabled: true,
          },
          {
            label: '仪表里程',
            value: 'recevieMileage',
            type: 'input',
          },
          {
            label: '上传附件',
            value: 'imageFile',
            type: 'img',
            unit: 'km',
            accept: 'image/*',
            attr: {
              limit: 1,
            },
            default: [],
          },
          {
            label: '司机手机',
            value: 'receiveUserPhone',
            type: 'input',
          },
          // {
          //   label: '司机姓名',
          //   value: 'receiveUserName',
          //   type: 'input',
          //   disabled: true,
          // },
          {
            label: '备注说明',
            value: 'receiveRemark',
            type: 'input',
            attr: {
              type: 'textatea',
            },
          },
        ],
        rules: {
          orderId: [ // 订单编号
            { required: true, message: '请输入订单编号', trigger: 'blur' },
          ],
          recevieMileage: [ // 仪表里程
            { required: true, message: '请输入仪表里程', trigger: 'blur' },
          ],
          imageFile: [ // 上传附件
            { required: true, message: '请选择上传附件', trigger: 'blur' },
          ],
          receiveUserPhone: [ // 司机手机
            { required: true, message: '请输入司机手机', trigger: 'blur' },
          ],
          receiveRemark: [ // 备注说明
            { required: true, message: '请输入备注说明', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    async sub () {
      let formData = await this.$refs.baseForm.sub();
      if (formData) {
        formData.mileageFileId = formData.imageFile[0].id;
        formData.mileageFileUrl = formData.imageFile[0].url;
        delete formData.imageFile;
        // 查询司机信息
        const userRes = await orderTimeQueryDriverByPhone({
          billId: formData.receiveUserPhone,
        });
        if (!userRes.failed) {
          formData = {
            receiveUserId: userRes.userId,
            receiveUserName: userRes.linkman,
            ...formData,
          };
        } else {
          formData = null;
        }
      }
      return formData;
    },
    async cacheData () {
      const res = await this.$refs.baseForm.getVal();
      return res;
    },
    async init (data = {}) {
      data.orderId = this.$route.query.id;
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
